import React, { Component } from 'react';
import querystring from 'querystring';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { Menu, MenuItem } from '@material-ui/core';

const styles = theme => ({
  menu: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#f5f5f5',
    '& > *': {
      color: '#403f41'
    }
  },
  menuPaper: {
    borderRadius: theme.shape.borderRadius,
    marginTop: '41px',
    background: 'rgba(0, 0, 0, 0)'
  },
  selected: {
    color: theme.palette.primary.main
  }
});

class Sort extends Component {
  constructor(props) {
    super(props);

    const decodedQuery = querystring.decode(
      props.location.search.replace('?', '')
    );

    this.productSortingTypes = {
      LATEST: 'added_favorites_desc',
      RELEVANCE: 'relevance',
      NEW: 'new',
      LIKES: 'likes',
      PRICE_DESC: 'price_desc',
      PRICE_ASC: 'price_asc'
    };

    this.dresserSortingTypes = {
      NEW: 'new',
      POPULAR: 'popular',
      BEST: 'best'
    };

    this.sortingTypes = props.dressers
      ? this.dresserSortingTypes
      : this.productSortingTypes;

    this.state = {
      currentSorting:
        decodedQuery.sort || (props.dressers ? this.sortingTypes.BEST : null)
    };
  }

  handleChange = sorting => {
    if (!sorting && this.state.currentSorting !== this.sortingTypes.NEW) {
      this.props.changeSort(this.state.currentSorting);
      return;
    }
    if (
      this.state.currentSorting === sorting ||
      (this.state.currentSorting === null &&
        sorting === this.sortingTypes.LATEST)
    ) {
      return;
    }
    this.setState({ currentSorting: sorting }, () => {
      if (
        this.props.location.pathname.includes !== '/productos' &&
        this.props.location.pathname.includes !== '/productos/favoritos' &&
        !this.props.location.pathname.includes('vestidor') &&
        this.props.location.pathname !== '/productos' &&
        this.props.location.pathname !== '/productos/favoritos'
      ) {
        this.props.history.replace({ pathname: '/productos' });
      }
      this.props.changeSort(sorting);
    });
  };

  render() {
    const { classes, favorites } = this.props;

    if (this.props.dressers) {
      return (
        <Menu
          classes={{
            list: classes.menu,
            paper: classes.menuPaper
          }}
          open={this.props.open}
          anchorEl={this.props.anchorEl}
          keepMounted
          onClose={this.props.onClose}
        >
          <MenuItem
            onClick={() => this.handleChange(this.sortingTypes.NEW)}
            className={
              this.state.currentSorting === this.sortingTypes.NEW
                ? classes.selected
                : ''
            }
          >
            · Más nuevos
          </MenuItem>
          <MenuItem
            onClick={() => this.handleChange(this.sortingTypes.BEST)}
            className={
              this.state.currentSorting === this.sortingTypes.BEST
                ? classes.selected
                : ''
            }
          >
            · Mejores vendedoras
          </MenuItem>
          <MenuItem
            onClick={() => this.handleChange(this.sortingTypes.POPULAR)}
            className={
              this.state.currentSorting === this.sortingTypes.POPULAR
                ? classes.selected
                : ''
            }
          >
            · Más seguidores
          </MenuItem>
        </Menu>
      );
    }

    return (
      <Menu
        classes={{
          list: classes.menu,
          paper: classes.menuPaper
        }}
        open={this.props.open}
        anchorEl={this.props.anchorEl}
        keepMounted
        onClose={this.props.onClose}
      >
        {favorites && (
          <MenuItem
            onClick={() => this.handleChange(this.sortingTypes.LATEST)}
            className={
              this.state.currentSorting === this.sortingTypes.LATEST ||
              this.state.currentSorting === null
                ? classes.selected
                : ''
            }
          >
            · Últimos
          </MenuItem>
        )}
        <MenuItem
          onClick={() => this.handleChange(this.sortingTypes.RELEVANCE)}
          className={
            this.state.currentSorting === this.sortingTypes.RELEVANCE
              ? classes.selected
              : ''
          }
        >
          · Destacados
        </MenuItem>
        <MenuItem
          onClick={() => this.handleChange(this.sortingTypes.NEW)}
          className={
            this.state.currentSorting === this.sortingTypes.NEW
              ? classes.selected
              : ''
          }
        >
          · Más nuevos
        </MenuItem>
        <MenuItem
          onClick={() => this.handleChange(this.sortingTypes.LIKES)}
          className={
            this.state.currentSorting === this.sortingTypes.LIKES
              ? classes.selected
              : ''
          }
        >
          · Más likes
        </MenuItem>
        <MenuItem
          onClick={() => this.handleChange(this.sortingTypes.PRICE_DESC)}
          className={
            this.state.currentSorting === this.sortingTypes.PRICE_DESC
              ? classes.selected
              : ''
          }
        >
          · Mayor precio
        </MenuItem>
        <MenuItem
          onClick={() => this.handleChange(this.sortingTypes.PRICE_ASC)}
          className={
            this.state.currentSorting === this.sortingTypes.PRICE_ASC
              ? classes.selected
              : ''
          }
        >
          · Menor precio
        </MenuItem>
      </Menu>
    );
  }
}

export default withStyles(styles)(withRouter(Sort));
